import SettlementMappingEdit from './SettlementMappingEdit';
import SettlementMappingList from './SettlementMappingList';

const resource = {
  list: SettlementMappingList,
  //   edit: SettlementMappingEdit,
};

export default resource;
